import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=1c408581"
import script from "./PermissionDenied.vue?vue&type=script&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c408581')) {
      api.createRecord('1c408581', component.options)
    } else {
      api.reload('1c408581', component.options)
    }
    module.hot.accept("./PermissionDenied.vue?vue&type=template&id=1c408581", function () {
      api.rerender('1c408581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/http/views/PermissionDenied.vue"
export default component.exports